import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import userPostCreateUser from '../../../hooks/useApi/usePostCreateAccountUser';
import CreateUserForm from './CreateUserForm';
import CreateUserContext, { CreateUserCtx } from './CreateUserContext';
import CreateUserDialogue from './CreateUserDialogue';
import { CreateUserDialogueHandler, DialogueHandlerProps } from '../types';

type FC = FunctionComponent;

const CreateUserContainer: FC = () => {
  const history = useHistory();
  const [CreateUserError, setCreateUserError] = useState('');
  const [showCreateUserErrorAlert, setShowCreateUserErrorAlert] = useState(false);
  const [showCreateUserSuccessAlert, setShowCreateUserSuccessAlert] = useState(false);
  const [shouldCreateUser, setShouldCreateUser] = useState(false);
  const [CreateUserResponse, createUser] = userPostCreateUser({});

  const CreateUser: CreateUserCtx = {
    showCreateUserSuccessAlert,
    showCreateUserErrorAlert,
    CreateUserError,
  };

  const DefaultCreateUser: vp.CreateUserRequest = {
    EmailAddress: '',
    SendEmail: true,
    Role: '',
  };

  const handlers = {
    handleDialogue: (handlerProps: DialogueHandlerProps<CreateUserDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: CreateUserDialogueHandler = {
        create: {
          success: {
            default: () => {
              setShowCreateUserSuccessAlert(false);
              history.push('/users');
            },
          },
          fail: {
            default: () => {
              setShowCreateUserErrorAlert(false);
              setCreateUserError('');
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
    onChangeCreateUser: (values: vp.CreateUserRequest) => {
      setShouldCreateUser(true);

      createUser(values);
    },
  };

  useEffect(() => {
    if (shouldCreateUser) {
      setShouldCreateUser(false);

      const { Success, ErrorMessage } = CreateUserResponse;

      if (Success === true) {
        setShowCreateUserSuccessAlert(true);
      } else {
        setCreateUserError(ErrorMessage);
        setShowCreateUserErrorAlert(true);
      }
    }
  }, [CreateUserResponse]);

  return (
    <CreateUserContext.Provider value={CreateUser}>
      <CreateUserForm defaultValues={DefaultCreateUser} handlers={handlers} />
      <CreateUserDialogue handleDialogue={handlers.handleDialogue} />
    </CreateUserContext.Provider>
  );
};

export default CreateUserContainer;
